import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '@liberty-financial/ng-components';

import { SparkPlusModalModule } from '@shared/components/modal/modal.module';

import { CommandComponent } from './command/command.component';
import { FailureComponent } from './failure/failure.component';
import { LoadDirective } from './load.directive';
import { LoadingIndicatorComponent } from './loading-indicator.component';

@NgModule({
  declarations: [
    LoadDirective,
    LoadingIndicatorComponent,
    CommandComponent,
    FailureComponent
  ],
  exports: [LoadDirective, LoadingIndicatorComponent, CommandComponent],
  imports: [CommonModule, SparkPlusModalModule, IconModule]
})
export class LoadModule {}
